import styled from 'styled-components'

export const Container = styled.div`
  padding-bottom: 30px;
  max-width: 1300px;
  height: 450px;
  font-family: Montserrat, sans-serif;
`
